module.exports = __webpack_public_path__ + "img/catalan.ed5b0bc2.svg";